import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// No 0/O, 1/I/L — safe to read aloud or handwrite
const SAFE_CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
const SAFE_LETTERS = 'ABCDEFGHJKMNPQRSTUVWXYZ';

// Build 4-char prefix from family name (letters only, padded with random letters)
function makeFamilyPrefix(familyName) {
  const letters = (familyName || '').toUpperCase().replace(/[^A-Z]/g, '');
  let prefix = letters.slice(0, 4);
  while (prefix.length < 4) {
    prefix += SAFE_LETTERS[Math.floor(Math.random() * SAFE_LETTERS.length)];
  }
  return prefix;
}

// Generate a 9-char code: 4-letter prefix + 5 random chars (stored without dash)
function generateFamilyCode(familyName) {
  const prefix = makeFamilyPrefix(familyName);
  let suffix = '';
  for (let i = 0; i < 5; i++) {
    suffix += SAFE_CHARS[Math.floor(Math.random() * SAFE_CHARS.length)];
  }
  const code = `${prefix}${suffix}`;
  if (code.includes('666')) return null;
  return code;
}

export async function generateUniqueFamilyCode(familyName = '') {
  for (let attempt = 0; attempt < 20; attempt++) {
    const code = generateFamilyCode(familyName);
    if (!code) continue; // contained 666, retry
    const snap = await getDocs(query(collection(db, 'families'), where('familyCode', '==', code)));
    if (snap.empty) return code;
  }
  throw new Error('Could not generate a unique family code. Please try again.');
}

// Strip formatting for Firestore lookup (uppercase, letters+digits only, no dash/spaces)
export function normalizeFamilyCode(raw) {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

// Display with dash after 4th char: "PEZZTGW7K" → "PEZZ-TGW7K"
export function displayFamilyCode(code) {
  if (!code) return '';
  const c = normalizeFamilyCode(code);
  return c.length > 4 ? `${c.slice(0, 4)}-${c.slice(4)}` : c;
}
